'use client';

import {
  SignalStage,
  type SignalStageType,
} from '@terra/shared-schemas-orchestrator';
import { Box, token } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Badge, Tooltip } from '../..';

type SignalStageBadgeConfig = {
  dotColor: string;
};

const SIGNAL_STAGE_BADGE_CONFIG: Record<
  SignalStageType,
  SignalStageBadgeConfig
> = {
  [SignalStage.NEW]: {
    dotColor: token('colors.bg.graphs.gray'),
  },
  [SignalStage.IN_TESTING]: {
    dotColor: token('colors.bg.graphs.purple'),
  },
  [SignalStage.NEEDS_REVIEW]: {
    dotColor: token('colors.bg.graphs.yellow'),
  },
  [SignalStage.TESTED]: {
    dotColor: token('colors.bg.graphs.green'),
  },
};

export type SignalStageBadgeProps = {
  stage: SignalStageType | null | undefined;
};

export const SignalStageBadge = ({ stage }: SignalStageBadgeProps) => {
  const tStage = useTranslations('designSystem.signals.lifecycle.stage');

  if (!stage) return null;

  const stageConfig = SIGNAL_STAGE_BADGE_CONFIG[stage];
  if (!stageConfig) return null;

  return (
    <Tooltip title={tStage('label')}>
      <Badge
        variant="outline"
        size="sm"
        bg="transparent"
        borderColor="transparent"
        icon={
          <Box
            w={1.5}
            h={1.5}
            borderRadius="full"
            style={{ backgroundColor: stageConfig.dotColor }}
          />
        }
      >
        {tStage(stage)}
      </Badge>
    </Tooltip>
  );
};
